import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import PricingTable from "../components/pricingTable"
import PricingFold from "../components/pricingFold"
import PricingQa from "../components/pricingQa"
import LastCall from "../components/homeLastCall"

const SecondPage = () => (
  <Layout>
    <SEO slug="/pricing" />
    <PricingFold />
    <PricingTable />
    <PricingQa />
    <LastCall />
  </Layout>
)

export default SecondPage
